export function singleton<T>(key: string, init: () => T): T {
  const symbol = Symbol.for(`com.xsolla.mit/${key}`);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const global = globalThis as any;
  global[symbol] ??= init();
  return global[symbol];
}
